module.exports = __webpack_public_path__ + "static/media/CT_2019_30446A_pdf.11a2ed09.pdf";